module.exports = __webpack_public_path__ + "static/media/jelly-old.62cd71c5.svg";